import Vue from 'vue'
import VueRouter from 'vue-router'

import {readToken,deleteToken} from '@/utils/auth'
import store from '@/store'
import {Message} from 'element-ui'
import routes from './routes'
Vue.use(VueRouter)

/* ************增强开始************** */
function enhance (name,source){
  // 将VueRouter原型上原始的push保存一份
  const origin = source.prototype[name]
  // 修改VueRouter原型上的push
  source.prototype[name] = function(location,onSuccess,onError){
    if(onSuccess || onError){
      return origin.call(this,location,onSuccess,onError)
    }else{
      return origin.call(this,location).catch(()=>{})
    }
  }
}
enhance('push',VueRouter)
enhance('replace',VueRouter)
/* *************增强结束************* */

const router = new VueRouter({
  mode:'history',
  scrollBehavior (to,from) {
    return {x:0,y:0}
  },
  routes
})

const authPath = ['/trade','/pay','/paysuccess','/myorder']
//全局导航守卫
router.beforeEach(async(to,from,next)=>{
  //从localStorage中读取token
  const token = readToken()
  //判断token是否存在
  if(token){
    console.log('你登录过，我要继续从vuex中读取用户信息')
    //从vuex中读取用户信息
    const {info} = store.state.user
    //判断用户信息是否为空
    if(info.id){
      console.log('要token有token，要信息有信息，直接放行')
      //放行
      next()
    }else{
      console.log('虽然有token，但没信息，拿着token去要信息')
      try {
        //获取用户信息
        await store.dispatch('user/getUserInfo')
        console.log('拿着你的token获取到了用户信息，漂亮！放行！')
        //放行
        next()
      } catch (error) {
        console.log('拿着你的token没有获取到用户信息，你那个破token失效了，我帮你删了，放行到登录')
        //删除已经不靠谱的token
        deleteToken()
        //放行到登录
        next('/login')
      }
    }
  }else{
    console.log('你没有登录，所以有些敏感路由，你不能去了')
    if(authPath.includes(to.path)){
      console.log('你没登录，别乱看')
      Message.warning('请先登录！')
      next('/login')
    }else{
      //放行
      next()
    }
    
  }
})

export default router

